import produce from "immer";
import ButtonIcon from "../../shared/controls/ButtonIcon";
import FieldTextBox from "../../shared/controls/fieldTextBox";

const CentroCosto = ({ entity, soloLectura, onChange, errors }) => {
    console.log(entity.clienteCentroCostos)
    const agregarConfiguracion = () => {
        const newList = produce(entity?.clienteCentroCostos, draft => {
            draft.push({});
        });

        onChange(newList, 'clienteCentroCostos');
    };

    const actualizar = (value, propertyName, index) => {
        console.log(value)
        const newList = produce(entity?.clienteCentroCostos, draft => {
            draft[index][propertyName] = value;

            if (propertyName === 'clienteCentroCostos') {
                draft[index]['clienteCentroCostosId'] = value?.id;
            }
        });

        onChange(newList, 'clienteCentroCostos');
    };

    const eliminar = (index) => {
        const newList = produce(entity?.clienteCentroCostos, draft => {
            draft.splice(index, 1);
        });

        onChange(newList, 'clienteCentroCostos');
    };

    return (
        <div className="form-row">
            <h5>Centro de Costos</h5>
            <table className="table table-borderless">
                <thead className="thead-light">
                    <tr>
                        <th>NOMBRE CENTRO DE COSTO</th>      
                        <th>ID</th>      
                        <th>LINE ID</th>                        
                        <th className={'ag-grid header-icons'} style={{ with: '10%' }}>
                            {!soloLectura &&
                                <ButtonIcon title={'Agregar Configuración'} iconName={'SiAddthis'} className="grid-action"
                                    onClick={agregarConfiguracion} />
                            }
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {entity?.clienteCentroCostos?.map((item, index) => {
                        return (
                            <tr key={index}>
                                <td className="input">
                                    <FieldTextBox name={'nombre'} value={item.nombre} colMd={6} placeholder={'NOMBRE CENTRO DE COSTO'}  disabled={soloLectura}
                                        errors={errors != null && errors[`clienteCentroCostos[${index}]`] != null ? errors[`clienteCentroCostos[${index}]`] : ''}
                                        onChange={(value, propertyName) => actualizar(value, propertyName, index)} className={'mt-2'} />
                                </td>
                                <td className="input">
                                    <FieldTextBox name={'IDc'} value={item.iDc} colMd={6} placeholder={'ID'}  disabled={soloLectura}
                                        errors={errors != null && errors[`clienteCentroCostos[${index}]`] != null ? errors[`clienteCentroCostos[${index}]`] : ''}
                                        onChange={(value, propertyName) => actualizar(value, propertyName, index)} className={'mt-2'} />
                                </td>
                                <td className="input">
                                    <FieldTextBox name={'LineId'} value={item.lineId} colMd={6} placeholder={'LINE ID'}  disabled={soloLectura}
                                        errors={errors != null && errors[`clienteCentroCostos[${index}]`] != null ? errors[`clienteCentroCostos[${index}]`] : ''}
                                        onChange={(value, propertyName) => actualizar(value, propertyName, index)} className={'mt-2'} />
                                </td>
                                <td>
                                    {!soloLectura &&
                                        <ButtonIcon title={'Eliminar'} iconName={'RiDeleteBinLine'}
                                            onClick={() => eliminar(index)} />
                                    }
                                </td>
                            </tr>
                        )
                    })}
                </tbody>
            </table>
        </div >
    );
};

export default CentroCosto;